import { Box } from '@chakra-ui/react'
import { Breakpoint } from 'presentation/components/Breakpoint'
import { EverythingYouNeedGrid } from 'presentation/screens/AuthScreens/components/EverythingYouNeedGrid/EverythingYouNeedGrid'
import { SignInCard } from 'presentation/screens/AuthScreens/components/SignInCard'

export const SignInScreen = () => (
  <Box h='var(--app-height)'>
    <Breakpoint
      mobSm={<SignInCard overflow='auto' h='100%' />}
      mob={(
        <EverythingYouNeedGrid>
          <SignInCard />
        </EverythingYouNeedGrid>
      )}
    />
  </Box>
)
